<template>
  <section :class="bemBlock">
    <p v-if="colorName" :class="[bemElement('color'), bemElement('text-line')]">
      {{ $msg('label.color', 'product') + ': ' }}
      <span :class="bemElement('color-name')">{{ colorName }}</span>
    </p>
    <p
      v-if="product.bylModelInfo"
      :class="[bemElement('model'), bemElement('text-line')]"
    >
      {{ $msg('label.model', 'product') + ': ' + product.bylModelInfo }}
    </p>
    <p
      v-if="!product.bylModelInfo && product.bylSpecialRelevantInfo"
      :class="[bemElement('special-relevant-info'), bemElement('text-line')]"
    >
      {{ product.bylSpecialRelevantInfo }}
    </p>
    <p
      v-if="!isMarketWithoutSale && product.bylOnlineExclusive"
      :class="[bemElement('online-exclusive'), bemElement('text-line')]"
    >
      <BaseTag
        type="detail"
        subtype="secondary"
        :text="$msg('tag.exclusive', 'product')"
      />
    </p>
  </section>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import productPropColorMixin from '../mixins/productPropColorMixin';
import BaseTag from './BaseTag.vue';

const { FRONT_CONFIG } = window;

export default {
  name: 'TheProductDetailsAdditionalInfo',

  components: {
    BaseTag,
  },

  mixins: [bemClassesMixin, productPropColorMixin],

  data() {
    return {
      isMarketWithoutSale: FRONT_CONFIG?.isMarketWithoutSale,
    };
  },

  computed: {
    colorName() {
      return this.colors.filter((color) => color.selected)[0]?.displayValue;
    },
  },
};
</script>
